import {atom} from "recoil";

/**
 * 휴가 사유 텍스트 필드
 * @type {(param: SerializableParam) => RecoilState<{NO: string, keyName: *, category: string}>}
 */
export const vacationUseDayValueAtom = atom({
    key: "vacationUseDayValueAtom",
    default: ""
})